export default __webpack_public_path__ + "static/media/12.93dc8205.jpg";